import {Component, OnInit, ChangeDetectorRef, OnDestroy} from '@angular/core';
import { Router } from '@angular/router';
import { ReplaySubject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AppService } from '@irb/app.service';
import { PageService } from '@irb-common/services/page.service'; 
import { IrbDashboardService } from '@irb/irb-dashboard/irb-dashboard.service';
import { IBlotterSummaryDetails } from '@irb/irb-dashboard/irb-dashboard.model';
import { IApplyFilterOnLanding } from '@irb/app.model';
import {UtilityService} from "@irb-common/services/utility.service";

@Component({ standalone: false,
  selector: 'irb-com-blotter',
  templateUrl: './com-blotter.component.html',
  styleUrls: ['./com-blotter.component.scss']
})
export class ComBlotterComponent implements OnInit, OnDestroy {
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);
  data: IBlotterSummaryDetails = {
    activeBlotterTradesCount: null,
    requiresAttentionCount: null,
    pendingCount: null,
    filledCount: null,
  };
  loadedActive: boolean;
  loadedFilled: boolean;
  chartData: any;
  colors: Array<string> = [
    "#EE0000",
    "#FF8800",
    "#3C842B"
  ];

  options: any = {
    responsive: true,
    maintainAspectRatio: false,
    circumference: 180,
    rotation: 270,
    cutoutPercentage: 50,
    plugins: {
      legend: {
        display: false
      },
      tooltip: {
        enabled: false
      }
    }
  };

  constructor(
    public as: AppService,
    public ps: PageService, 
    private dbs: IrbDashboardService, 
    private cdr: ChangeDetectorRef, 
    private router: Router
  ) {}

  ngOnInit() {
    this.ps.getUserDetails().pipe(takeUntil(this.destroyed$)).subscribe((d) => {   
      if(d) {
        this.ps.deserializePageState(this.as.getFromSession("pageState"),["blotterGridDiv","blotterGridDivRes"]);

        this.dbs.getBlotterDetailsActive().pipe(takeUntil(this.destroyed$)).subscribe((d: any) => {
          this.data.activeBlotterTradesCount = d.activeBlotterTradesCount;
          this.data.requiresAttentionCount = d.requiresAttentionCount;
          this.data.pendingCount = d.pendingCount;
          if (this.loadedFilled) {
            this.update();
            this.cdr.detectChanges();
          }
          this.loadedActive=true;
        });
        this.dbs.getBlotterDetailsFilled().pipe(takeUntil(this.destroyed$)).subscribe((d: any) => {
          this.data.filledCount = d.filledCount;
          if (this.loadedActive) {
            this.update();
            this.cdr.detectChanges();
          }
          this.loadedFilled=true;
        });
      }
    });
  }

  ngOnDestroy() {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  update() {
    const a = (this.data.requiresAttentionCount / this.data.activeBlotterTradesCount) * 100;
    const b = (this.data.pendingCount / this.data.activeBlotterTradesCount) * 100;
    const c = (this.data.filledCount / this.data.activeBlotterTradesCount) * 100;
    const t = a + b + c;

    this.chartData = {
      datasets: [
          {
              data: (t > 0) ? [a,b,c] : [100],
              backgroundColor: (t > 0) ? this.colors : ["#CECECE"],
              hoverBackgroundColor: (t > 0) ? this.colors : ["#CECECE"],
              borderWidth: 2,
              hoverBorderColor: ["#FFFFFF"]
          }
      ]
    };
  }

  showRequiresAttention() {
    const a = ['Error','Warning', 'Cancel rejected', 'Allocations failed', 'Cancel requested'];
    const state: IApplyFilterOnLanding = {
      isUpdatRequired: true,
      filterModel: { name: 'orderStatus', value: a, isUpdatRequired: true }
    } as IApplyFilterOnLanding;

    this.router.navigateByUrl('/orders/order-blotter', { state: state });
  }

  showPending() {
    const a = ['Approved', 'On hold', 'Overridden', 'Validated'];
    const state: IApplyFilterOnLanding = {
      isUpdatRequired: true,
      filterModel: { name: 'orderStatus', value: a, isUpdatRequired: true }
    } as IApplyFilterOnLanding;

    this.router.navigateByUrl('/orders/order-blotter', { state: state });
  }

  // showSubmitted() {
  //   const a = ['Manually submitted', 'Partially filled', 'Pending validation', 'Exported to ThinkPipes'];
  //   this.ps.pageState.blotterGridDiv["filterData"]["dom_filterOrdStatus"] = a;
  //   this.ps.pageState.blotterGridDiv["filterString"] = "orderStatus=" + a.join(",");
  //   this.ps.serializePageState();
  //   this.router.navigate(['/orders/order-blotter']);
  // }

  showFilled() {
    const a = ['Filled'];
    const d =  UtilityService.convertDateTimeToETforFilter(new Date());
    const state: IApplyFilterOnLanding = {
      isUpdatRequired: true,
      tabname:'Closed',
      filterModels: [{ name: 'orderStatus', value: a, isUpdatRequired: true },
      {name: 'modifiedDate', value: {dateFrom:d, dateTo: d}, filter: 'inRange', isUpdatRequired: true}],
    } as IApplyFilterOnLanding;

    this.router.navigateByUrl('/orders/order-blotter', { state: state });
  }

}
